module.exports = __webpack_public_path__ + "img/payment-list.25693479.svg";